import React from 'react';

import {Trans, useTranslation} from 'react-i18next';
import {
    FontVariant,
    TextHeading,
    Text,
    Form,
    Bar,
    Button,
} from '@pexip/components';
import {TestId} from '../../../test/testIds';

export const RegistrationExpired: React.FC<{
    onReRegister: () => void;
    isLoading: boolean;
}> = ({onReRegister, isLoading}) => {
    const {t} = useTranslation();

    return (
        <>
            <TextHeading
                htmlTag="h2"
                fontVariant={FontVariant.H2}
                className="mb-2"
            >
                <Trans t={t} i18nKey="register.expired-title">
                    Registration expired
                </Trans>
            </TextHeading>
            <Text>
                <Trans t={t} i18nKey="register.expired-description">
                    Your registration session has expired. Please sign in again
                    to continue receiving calls.
                </Trans>
            </Text>
            <Form
                onSubmit={(event: React.FormEvent<HTMLFormElement>) => {
                    event.preventDefault();
                    onReRegister();
                }}
            >
                <Bar>
                    <Button
                        modifier="fullWidth"
                        type="submit"
                        size="large"
                        isLoading={isLoading}
                        data-testid={TestId.ButtonRegistrationReRegister}
                        className="mt-3"
                    >
                        <Trans t={t} i18nKey="register.expired-sign-in">
                            Sign in
                        </Trans>
                    </Button>
                </Bar>
            </Form>
        </>
    );
};
